module.exports = "<div class=\"program-list-container\">\r\n    <div class=\"program-container\" style=\"margin-left: -15px;\">\r\n        <app-subregions *ngFor=\"let subregionAssignment of subregionAssignments\" [subregionAssignment]=\"subregionAssignment\"></app-subregions>\r\n    </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/Uhm.Loops.Web/src/app/loan-officer-region-reference/subregion-list/subregion-list.component.html
// module id = ../../../../../src/app/loan-officer-region-reference/subregion-list/subregion-list.component.html
// module chunks = main